import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconTone: React.FC<IconProps> = ({ color = 'black', width = 24, height = 24 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 25 24"
            fill="none"
        >
            <path
                d="M3.06992 2.86055H17.7375C17.9584 2.86055 18.1375 2.68164 18.1375 2.46055C18.1375 2.23945 17.9584 2.06055 17.7375 2.06055H3.06992C2.84902 2.06055 2.66992 2.23945 2.66992 2.46055C2.66992 2.68164 2.84902 2.86055 3.06992 2.86055Z"
                fill={color}
            />
            <path
                d="M3.06992 6.01484H17.7375C17.9584 6.01484 18.1375 5.83594 18.1375 5.61484C18.1375 5.39375 17.9584 5.21484 17.7375 5.21484H3.06992C2.84902 5.21484 2.66992 5.39375 2.66992 5.61484C2.66992 5.83594 2.84902 6.01484 3.06992 6.01484Z"
                fill={color}
            />
            <path
                d="M3.06992 9.17109H17.7375C17.9584 9.17109 18.1375 8.99219 18.1375 8.77109C18.1375 8.55 17.9584 8.37109 17.7375 8.37109H3.06992C2.84902 8.37109 2.66992 8.55 2.66992 8.77109C2.66992 8.99219 2.84902 9.17109 3.06992 9.17109Z"
                fill={color}
            />
            <path
                d="M3.06992 12.3273H10.9199C11.1408 12.3273 11.3199 12.1484 11.3199 11.9273C11.3199 11.7062 11.1408 11.5273 10.9199 11.5273H3.06992C2.84902 11.5273 2.66992 11.7062 2.66992 11.9273C2.66992 12.1484 2.84902 12.3273 3.06992 12.3273Z"
                fill={color}
            />
            <path
                d="M3.06992 15.4816H14.543C14.7639 15.4816 14.943 15.3027 14.943 15.0816C14.943 14.8605 14.7639 14.6816 14.543 14.6816H3.06992C2.84902 14.6816 2.66992 14.8605 2.66992 15.0816C2.66992 15.3027 2.84902 15.4816 3.06992 15.4816Z"
                fill={color}
            />
            <path
                d="M14.943 18.2379C14.943 18.0168 14.7639 17.8379 14.543 17.8379H3.06992C2.84902 17.8379 2.66992 18.0168 2.66992 18.2379C2.66992 18.459 2.84902 18.6379 3.06992 18.6379H14.543C14.7639 18.6379 14.943 18.459 14.943 18.2379Z"
                fill={color}
            />
            <path
                d="M22.2695 10.5039H13.2047C12.9838 10.5039 12.8047 10.6828 12.8047 10.9039V13.709C12.8047 13.866 12.8967 14.0086 13.0396 14.0734C13.0926 14.0973 13.1488 14.109 13.2047 14.109C13.2998 14.109 13.3941 14.075 13.4686 14.0098L14.4545 13.1445H16.2779V21.5395C16.2779 21.7605 16.457 21.9395 16.6779 21.9395H18.5186C18.7395 21.9395 18.9186 21.7605 18.9186 21.5395V13.1445H21.0195L22.0057 14.0098C22.1236 14.1133 22.2916 14.1375 22.4346 14.0734C22.5777 14.0086 22.6695 13.866 22.6695 13.709V10.9039C22.6695 10.6828 22.4904 10.5039 22.2695 10.5039ZM18.1186 21.1395H17.0779V13.1445H18.1186V21.1395ZM21.8695 12.8262L21.434 12.4438C21.3609 12.3797 21.2672 12.3445 21.1701 12.3445H18.5186H16.6779H14.3039C14.2068 12.3445 14.1131 12.3797 14.04 12.4438L13.6047 12.8258V11.3039H21.8695V12.8262Z"
                fill={color}
            />
        </svg>
    );
};

export default IconTone;
